import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type ITutorialRepository } from '@webapp/platform/iam/business-logic/interfaces/ITutorialRepository'
import { type TutorialStatusConstructor } from '@webapp/platform/iam/entities/TutorialStatus'
import { type TutorialStatusApiModel } from '../../api-models/TutorialStatusApiModel'
import { mapTutorialStatusApiModel } from '../../mappers/mapTutorialStatusApiModel'

interface IDependency {
  httpClient: IHttpClient
}

export class TutorialRepository implements ITutorialRepository {
  constructor(private readonly deps: IDependency) {}

  async getTutorialStatus(): Promise<TutorialStatusConstructor> {
    try {
      const res =
        await this.deps.httpClient.get<TutorialStatusApiModel>('/api/tutorial/')

      return mapTutorialStatusApiModel(res.data)
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }

  async dismissPunchOutApprovalWarning(): Promise<void> {
    try {
      await this.deps.httpClient.post('/api/tutorial/', {
        complete: {
          major: 'approval',
          minor: 'punchout_confirmation',
          version: 1,
        },
      })
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
